import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Card,
  Col,
  Row,
  Switch,
  Button,
  Badge,
  Avatar,
  Spin,
  Checkbox,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
  Space,
} from "antd";
import {
  CloseOutlined,
  LeftOutlined,
  RadiusBottomleftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Styled from "styled-components";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Line,
} from "recharts";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import ExportIcon from "../../assets/images/Export-Icon.svg";
import { CALL_API } from "../../Common/api";
import UIModal from "../../Reusablecomponents/UIModal";
import { useNavigate } from "react-router-dom";
import {
  ButtonFilled,
  Buttontransparent,
  DashboardButton,
  DashboardNav,
} from "../../Reusablecomponents/UIButtons";
import { widgets } from "../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import duration from "dayjs/plugin/duration";
import { ReactComponent as LeafMud } from "../../assets/images/mdi_leaf.svg";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
import { color } from "highcharts";
import Dashboard from "./Dashboard";

dayjs.extend(duration);

const { Option } = Select;
const { RangePicker } = DatePicker;

const Styledashboard = Styled.div`
.ant-card .ant-card-body
 /* {padding:14px !important */




.range_picker{
  width: 100% !important;
}
.trends-value{
font-size: 12px;
text-align: end;
}
.overview-body{
padding: 0px;
gap: 24px;
}
img {
  cursor: pointer !important;
}
.addwidget-btn{
  background-color: #E8FFEC;
  color:#2C963D;
  border:none;
}
.ant-card-head{
border-bottom: none;
}
.rechart-legend-icon{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  }
.stats-card{
   display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: left; 
  height: 100%; 
  text-align: left;
  }
  .status_card1{
       display: flex;
    justify-content: space-between;;
    padding:3px;
  }
    .ai-overview{
background : none;
box-shadow : none;
}

  .presentageValue{
  position:absolute;
  right:15px;
  font-size: 12px;
  
  }
  .ant-switch-checked {
  background-color: #31AB46 !important;
}
.Iconbg{
width:38px;
height:38px;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;
background-color: #EBF7ED;
}

.all-charts-scroll-container {
  display: flex;
  overflow-x: auto!important;
  gap: 12px;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin; 
}

.all-charts-scroll-container::-webkit-scrollbar {
  height: 8px; /* Make scrollbar visible */
  background-color: #f1f1f1;
}

.all-charts-scroll-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}
.chart-card {
  width: 100%; 
  max-width: 100%;
  min-width: 300px; 

}

.chart-container {
  width: 100%;
  height: 300px; /* Adjust height as needed */
}

@media (max-width: 425px) {

  .ant-card-head {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px; 
  }

  .ant-card-head-title {
    margin-bottom: 0px;
    font-size: 16px; /* Optional, in case font size is collapsing */
overflow: visible
    // display: block; /* Ensures visibility */
  }

  .ant-card-extra {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .trends-value {
    font-size: 12px;
    //     flex-direction: column;
    // justify-content: center;
    // align-items: center;
    text-align: start;
    
  }
      .ant-switch {
      margin-left: 0px;
}

  .overview-body {
    padding: 0px;
    gap: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 0 !important;
    
  }

  .addwidget-btn {
    background-color: #e8ffec;
    color: #2c963d;
    border: none;
    margin-left: 0px;
    margin-bottom: 10px;
  }
}


@media (min-width: 320px) and (max-width: 426px){
.tripPaginatedData{
width:400px !important;
}

#top-clients .recharts-surface{
    margin-top:-35%;
}
.toptenclients{
 margin-top:-60%;
}
.ant-card-head{
  padding:4px !important;
}
}

`;

const AIDashboard = () => {
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const [form] = Form.useForm();
  const [cardData, setCardData] = useState([]);
  const [cardData1, setCardData1] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isfilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [userWidgets, setUserWidgets] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({
    Duration: "CurrentMonth",
    Daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const [trends, setTrends] = useState([]);

  const filteredWidgets = widgets?.filter((item) =>
    item?.name.toLowerCase()?.includes(searchText.toLowerCase()),
  );

  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AIPLS_DSH", "EX"),
    [reduxPermissions],
  );

  const handleChange = (values) => {
    if (values?.includes("all")) {
      setSelectedWidgets(widgets?.map((item) => item?.value));
    } else {
      setSelectedWidgets(values);
    }
  };

  const getTrends = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `dash/geTrends`, {
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),

        Duration: formValues?.Duration || "",
      });
      setTrends(Array.isArray(data) ? data : []);
    } catch (error) {}

    setLoading(false);
  };

  const AddRemoveWidgets = async (widget, type) => {
    setLoading(true);
    const { data } = await CALL_API("POST", `dash/AddRemoveWidget`, {
      MCID: userInfo?.MCID,
      UID: userInfo?.UID,
      Widgets: widget,
      Type: type,
    });
    getUserWidget();
    setLoading(false);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsFilterModalOpen(false);
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };

  // useEffect(() => {
  //   getFilterCount();
  // }, [formValues]);

  // consignment Chart
  const [loading, setLoading] = useState();
  const [consignmentAndDeliveredData, setConsignmentAndDeliveredData] =
    useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const getConsignmentAndDeliveryt = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        `/dash/getConsignmentAndDelivery`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          Receiver: formValues?.consignee || 0,
          Shipper: formValues?.transporter || 0,
          VehId: formValues?.vehicle || "0",
          Device: formValues?.deviceid || "",
          Triptype: formValues?.tripType || 0,
          Duration: formValues?.Duration || "",
        },
      );
      setConsignmentAndDeliveredData(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };
  const maxPage = Math.floor(
    consignmentAndDeliveredData?.length / itemsPerPage,
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = Array.isArray(consignmentAndDeliveredData)
    ? consignmentAndDeliveredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage,
      )
    : [];

  // trip chart
  const [tripPerVehicleData, setTripPerVehicleData] = useState([]);
  const [tripCurrentPage, setTripCurrentPage] = useState(0); // Ensure loading state is declared

  const getTripPerVehicle = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `dash/getTripPerVehicle`, {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        Receiver: formValues?.consignee || 0,
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || 0,
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || 0,
        Duration: formValues?.Duration || "",
      });
      const selectedVehId = formValues?.vehicle;
      let sorted = [...(data || [])];

      // PRIORITIZE selected vehicle at the top
      if (selectedVehId) {
        sorted.sort((a, b) => {
          if (a.VehId === selectedVehId) return -1;
          if (b.VehId === selectedVehId) return 1;
          return b.value - a.value; // normal descending sort
        });
      }
      setTripPerVehicleData(data || []);
    } catch (error) {
      console.error("Failed to fetch trip per vehicle data", error);
    } finally {
      setLoading(false);
    }
  };

  const tripMaxPage = Math.ceil(tripPerVehicleData.length / itemsPerPage) - 1;

  const tripHandlePrev = () => {
    setTripCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const tripHandleNext = () => {
    setTripCurrentPage((prev) => Math.min(prev + 1, tripMaxPage));
  };

  // Paginated data for current page
  const tripPaginatedData = tripPerVehicleData
    .slice(tripCurrentPage * itemsPerPage, (tripCurrentPage + 1) * itemsPerPage)
    .filter((item) => !(item.Val == 0));

  //client chart
  const [clientsData, setClientsData] = useState([]);
  const [total, setTotal] = useState(0);
  const [clientCurrentPage, setClientCurrentPage] = useState(0);
  const clientitemsPerPage = 10;

  const getClients = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `dash/getToptenClient`, {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        Receiver: formValues?.consignee || 0,
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || 0,
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || 0,
        Duration: formValues?.Duration || "",
      });

      const parsed =
        data?.map((item) => {
          const value = parseInt(item?.Val?.split("~")?.[1]) || 0;
          return {
            name: item?.Data,
            value,
          };
        }) || [];

      const totalValue = parsed.reduce((sum, curr) => sum + curr.value, 0);

      setClientsData(parsed);
      setTotal(totalValue);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
    setLoading(false);
  };

  const clientMaxPage = Math.ceil(clientsData.length / clientitemsPerPage) - 1;

  const clientHandlePrev = () => {
    setClientCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const clientHandleNext = () => {
    setClientCurrentPage((prev) => Math.min(prev + 1, clientMaxPage));
  };

  const paginatedClients = clientsData.slice(
    clientCurrentPage * clientitemsPerPage,
    (clientCurrentPage + 1) * clientitemsPerPage,
  );

  //vehicle chart

  const [vehicleData, setVehicleData] = useState([]);
  const [vehiclePage, setVehiclePage] = useState(0);
  const vehicleitemsPerPage = 10; // Change based on your desired chunk size

  const getVehiclePerformance = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `dash/getDistanceFuelMileagePerVehicle`,
      {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        Receiver: formValues?.consignee || 0,
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || 0,
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || 0,
        Duration: formValues?.Duration || "",
      },
    );
    const selectedVehId = formValues?.vehicle;
    let sorted = [...(data?.mileage || [])];

    // PRIORITIZE selected vehicle at the top
    if (selectedVehId) {
      sorted.sort((a, b) => {
        if (a.VehId === selectedVehId) return -1;
        if (b.VehId === selectedVehId) return 1;
        return b.value - a.value; // normal descending sort
      });
    }
    setVehicleData(data?.mileage || []);
    setLoading(false);
  };

  // Sort by Mileage DESC (or Distance / Fuel based on requirement)
  const sortedVehicleData = useMemo(() => {
    return [...vehicleData].sort((a, b) => b.Mileage - a.Mileage);
  }, [vehicleData]);

  // Calculate max pages
  const vehicleMaxPage =
    Math.ceil(sortedVehicleData.length / vehicleitemsPerPage) - 1;

  // Pagination control
  const handleVehiclePrev = () => {
    setVehiclePage((prev) => Math.max(prev - 1, 0));
  };

  const handleVehicleNext = () => {
    setVehiclePage((prev) => Math.min(prev + 1, vehicleMaxPage));
  };

  // Slice paginated data
  const paginatedVehicleData = useMemo(() => {
    return sortedVehicleData
      .slice(
        vehiclePage * vehicleitemsPerPage,
        (vehiclePage + 1) * vehicleitemsPerPage,
      )
      .filter(
        (item) =>
          !(
            item.Distance === 0 &&
            item.Fuel === 0 &&
            item.Mileage &&
            Number(item.Mileage) === 0
          ),
      );
  }, [sortedVehicleData, vehiclePage]);

  const formattedTime = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0",
      )}`;
    }
  };

  const getColour = (value) => {
    return trends?.find((item, index) => item?.Description === value)?.Colour;
  };
  const getpercentage = (value) => {
    const trendval = trends.find((item) => item.Description === value);
    const percentage = trendval?.PercentageValue;
    return percentage ?? "0%";
  };

  const utilizationValue = `${cardData1?.vehicleUtilization || 0}% (${
    cardData1?.UsedVehicles || 0
  }/${cardData1?.TotalActiveVehicles || 0})`;
  const deliveryValue = `${cardData1?.deliveryRate ?? 0}%`;
  const cardDatas = [
    {
      title: "Total Trips",
      value: cardData?.totalTrips ?? 0,
      // value: 900,
      subtitle: "Total Trips",
      background: "#FFE2E5",
      percent: getpercentage("Trips"),
      unit: "",
      number: 0,
      color: getColour("Trips"),
    },
    {
      title: "Consignments",
      value: cardData?.totalConsignments ?? 0,
      // value: 1755,
      subtitle: "Total Consignments",
      background: "#FFF4DE",
      number: 1,
      color: getColour("Consignments Created vs Delivered"),
      percent: getpercentage("Consignments Created vs Delivered"),
    },
    {
      title: "Delivery Time (AVG)",
      value: formattedTime(cardData1?.totalAvgTripTime) ?? "00:00",
      //value: "19:35",
      subtitle: cardData1?.totalAvgTripTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#F3E8FF",
      number: 2,
      color: getColour("Avg DeliveryTime"),
      percent: getpercentage("Avg DeliveryTime"),
    },
    {
      title: "Loading Time (AVG)",
      value: formattedTime(cardData1?.totalLoadingTime) ?? "00:00",
      //value: "01:09",
      subtitle: cardData1?.totalLoadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#FFE2F7",
      number: 4,
      color: getColour("Loading Time"),
      percent: getpercentage("Loading Time"),
    },
    {
      title: "Loading Wait Time (AVG)",
      value: formattedTime(cardData1?.totalLoadingWaitTime) ?? "00:00",
      //value: "01:34",
      subtitle: cardData1?.totalLoadingWaitTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#EBFFDE",
      number: 5,
      color: getColour("Loading Wait"),
      percent: getpercentage("Loading Wait"),
    },
    {
      title: "Offloading Time (AVG)",
      value: formattedTime(cardData1?.totalOffloadingTime) ?? "00:00",
      //value: "21:00",
      subtitle: cardData1?.totalOffloadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#E8EDFF",
      number: 6,
      color: getColour("OffLoading Time"),
      percent: getpercentage("OffLoading Time"),
    },
    {
      title: "Offloading Wait Time (AVG)",
      value: formattedTime(cardData1?.totalOffloadingWaitTime) ?? "00:00",
      // value: "19:00",
      subtitle:
        cardData1?.totalOffloadingWaitTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#DCF8FC",
      number: 7,
      color: getColour("OffLoading wait Time"),
      percent: getpercentage("OffLoading wait Time"),
    },
    {
      title: "Fuel ",
      value: cardData?.totalFuel ?? 0,
      // value: "21449",
      subtitle: "Litres",
      background: "#FFF4DE",
      number: 9,
      color: getColour("Fuel per vehicle"),
      percent: getpercentage("Fuel per vehicle"),
    },
    {
      title: "Distance",
      value: (cardData?.totalDistance ?? 0).toFixed(2),
      // value: "119451",
      subtitle: "KMS",
      background: "#F3E8FF",
      number: 10,
      color: getColour("Distance per Vehicle"),
      percent: getpercentage("Distance per Vehicle"),
    },
    {
      title: "Mileage",
      value: cardData?.totalFuel
        ? (cardData.totalDistance / cardData.totalFuel).toFixed(2)
        : 0,
      // value: "119451",
      subtitle: "KM/L",
      background: "#E8EDFF",
      number: 11,
      color: getColour("Vehicle Mileage"),
      percent: getpercentage("Vehicle Mileage"),
    },
    {
      title: "Loading Cycle Time (AVG)",
      value: formattedTime(cardData1?.totalLoadingCycle) ?? "00:00",
      // value: "10:13",
      background: "#F3E8FF",
      subtitle: cardData1?.totalLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
      number: 12,
      color: getColour("Loading Cycle Times"),
      percent: getpercentage("Loading Cycle Times"),
    },
    {
      title: "Offloading Cycle Time (AVG)",
      value: formattedTime(cardData1?.totalOffLoadingCycle) ?? "00:00",
      // value: "10:40",
      background: "#EBFFDE",
      subtitle: cardData1?.totalOffLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
      number: 13,
      color: getColour("OffLoading Cycle Times"),
      percent: getpercentage("OffLoading Cycle Times"),
    },
    {
      title: "Time After Loading (AVG)",
      value: formattedTime(cardData1?.totalTimeAfterLoading) ?? "00:00",
      // value: "04:02",
      subtitle: cardData1?.totalTimeAfterLoading >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#E8EDFF",
      number: 14,
      color: getColour("Time After Loading"),
      percent: getpercentage("Time After Loading"),
    },
    {
      title: "Time After Offloading (AVG)",
      value: formattedTime(cardData1?.totalTimeAfterOffloading) ?? "00:00",
      //value: "04:08",
      subtitle:
        cardData1?.totalTimeAfterOffloading >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#DCF8FC",
      number: 15,
      color: getColour("Time After Offloading"),
      percent: getpercentage("Time After Offloading"),
    },
    {
      title: "Carbon Footprint",
      value: cardData1?.totalCarbonFootprint ?? 0,
      // value: "60388.9",
      subtitle: "KgCO2",
      background: " #DDF6E1",
      number: 16,
      leafimg: <LeafMud />,
      color: getColour("Carbon Footprint"),
      percent: getpercentage("Carbon Footprint"),
    },
    {
      title: "Delivery Rate",
      value: deliveryValue,
      // value: "60388.9",
      background: " #FFF4DE",
      number: 17,
      color: getColour("Delivery Rate"),
      percent: getpercentage("Delivery Rate"),
    },
    {
      title: "Vehicle Utilization",
      value: utilizationValue,
      // value: "60388.9",
      background: " #FFE2F7",
      number: 18,
      color: getColour("Vehicle Utilization"),
      percent: getpercentage("Vehicle Utilization"),
    },
  ];
  const mergedCardDatas = cardDatas.map((card) => {
    const matchingTrend = trends.find((trend) => trend.Slno === card.number);

    return {
      ...card,
      percent: matchingTrend ? `${matchingTrend.PercentageValue}%` : "",
      colour: matchingTrend?.Colour?.trim() || "",
    };
  });

  const Duration = [
    { label: "Current Month", value: "CurrentMonth" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  const getUserWidget = async () => {
    const { data } = await CALL_API("POST", `dash/getUserWidgets`, {
      mcId: userInfo?.MCID,
      userId: userInfo?.UID,
    });

    setUserWidgets(
      data?.[0]?.DASHWIDGETS ? data[0].DASHWIDGETS.split(",").map(Number) : [],
    );
  };

  const getCardData = async () => {
    const { data } = await CALL_API("POST", `dash/totalDashData`, {
      mcId: userInfo?.MCID,
      StartDate:
        dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      EndDate:
        dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      Cust: formValues?.consignor || 0,
      Receiver: formValues?.consignee || 0,
      Shipper: formValues?.transporter || 0,
      VehId: formValues?.vehicle || 0,
      Triptype: formValues?.tripType || 0,
      driver: formValues?.driver || 0,
      Duration: formValues?.Duration || "",
    });

    setCardData(data?.data);
    setCardData1(data?.data1);
  };

  const [cardOrder, setCardOrder] = useState(
    cardDatas.map((card) => card.number),
  );

  const [dragIndex, setDragIndex] = useState(null);

  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    const newOrder = [...cardOrder];
    const draggedItem = newOrder[dragIndex];

    newOrder.splice(dragIndex, 1);
    newOrder.splice(dropIndex, 0, draggedItem);
    setCardOrder(newOrder);
    setDragIndex(null);
  };

   useEffect(() => {
    const duration = formValues?.Duration;
    let range = [null, null];

    if (duration === "last_month") {
      range = [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ];
    } else if (duration === "CurrentMonth") {
      range = [dayjs().startOf("month"), dayjs().endOf("month")];
    } else if (duration === "current_year") {
      range = [dayjs().startOf("year"), dayjs().endOf("year")];
    } else if (duration === "today") {
      range = [dayjs(), dayjs()];
    } else if (duration === "---") {
      range = [null, null];
    }

    form.setFieldsValue({
      Daterange: range,
    });

    setFormValues((prev) => ({
      ...prev,
      Daterange: range,
    }));
  }, [formValues?.Duration]);

  useEffect(() => {
    setSelectedWidgets(userWidgets?.map((item) => item));
  }, [userWidgets]);
  // useEffect(() => {
  //   let newRange;
  //   if (form.getFieldValue("Duration") === "last_month") {
  //     newRange = [
  //       moment().subtract(1, "months").startOf("month"),
  //       moment().subtract(1, "months").endOf("month"),
  //     ];
  //   } else if (form.getFieldValue("Duration") === "CurrentMonth") {
  //     newRange = [moment().startOf("month"), moment().endOf("month")];
  //   } else if (form.getFieldValue("Duration") === "current_year") {
  //     newRange = [moment().startOf("year"), moment().endOf("year")];
  //   } else if (form.getFieldValue("Duration") === "today") {
  //     newRange = [moment(), moment()];
  //   } else if (form.getFieldValue("duration") === "---") {
  //     newRange = [null, null];
  //   }

  //   if (newRange) {
  //     form.setFieldValue("Daterange", newRange);
  //     setFormValues((prevValue) => {
  //       const updated = { ...prevValue, Daterange: newRange };
  //       // Call API here with updated values
  //       // getCardData(updated);
  //       return updated;
  //     });
  //   }
  // }, [formValues?.Duration]);
  const CustomHoverBar = (props) => {
    const { x, y, width, height, fill } = props;
    const [hovered, setHovered] = useState(false);

    const shrink = hovered ? 6 : 0; // Shrink width by 6px when hovered

    return (
      <rect
        x={x + shrink / 2} // shift to center after shrinking
        y={y}
        width={width - shrink}
        height={height}
        fill={fill}
        rx={4}
        ry={4}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ transition: "all 0.3s ease-in-out" }}
      />
    );
  };

  const ConsigndeliveryChart = ({ data }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
      if (containerRef.current)
        setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        if (containerRef.current)
          setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const chartWidth = Math.max(data?.length * 60, containerWidth - 60); // minus Y-axis width

    // Compute min/max for Y-axis
    const allValues = data.flatMap((item) => [item.Val, item.D1]);
    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <div
          ref={containerRef}
          style={{ display: "flex", width: "100%", background: "#fff" }}
        >
          {/* Fixed Y-axis */}
          <div
            style={{
              width: 50,
              height: 325,
              borderRight: "1px solid #eee",
              position: "sticky",
              left: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data}>
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: "#666", textAnchor: "end" }}
                  width={50}
                  domain={[minValue, maxValue]} // Sync scale
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Scrollable chart area */}
          <div style={{ overflowX: "auto", flex: 1 }}>
            <div style={{ width: chartWidth, height: 325 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={data}
                  margin={{ top: 40, right: 0, left: 0, bottom: 5 }}
                  barCategoryGap="0%"
                  barGap={0}
                >
                  <Legend
                    layout="horizontal"
                    align="center"
                    verticalAlign="top"
                    wrapperStyle={{
                      position: "absolute",
                      top: 0,
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRadius: "5px",
                    }}
                  />
                  <CartesianGrid stroke="none" />
                  <XAxis
                    dataKey="Data"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 10.5, fill: "#666" }}
                  />
                  <Tooltip />
                  <Bar
                    dataKey="Val"
                    name="Consignments"
                    fill="#E4A400"
                    radius={[4, 4, 0, 0]}
                    barSize={35}
                  />
                  <Bar
                    dataKey="D1"
                    name="Delivered"
                    fill="#00BC13"
                    radius={[4, 4, 0, 0]}
                    barSize={35}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <style>
          {`
            div::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
      </Spin>
    );
  };

  const TripPerVehicleChart = ({ data }) => {
    const hasData = data && data.length > 0;

    const allValues = data
      .flatMap((item) => [item.Val])
      .filter((v) => v !== null);

    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <ResponsiveContainer width="100%" height={380} id="Trip Per Vehicle">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
            barSize={28}
            cursor={hasData ? "pointer" : "default"} // ✅ disable pointer cursor
            barCategoryGap="2%"
            barGap={1}
          >
            <CartesianGrid vertical={false} horizontal={true} />
            <XAxis
              dataKey="Data"
              tickLine={false}
              interval={0}
              tick={{ fontSize: 11, fill: "#666" }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              domain={[minValue, maxValue]}
            />
            {hasData && <Tooltip />}
            <Bar
              dataKey="Val"
              name="Trips"
              fill="#0E9CD4"
              radius={[4, 4, 0, 0]}
              activeBar={hasData ? undefined : false}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };
  const COLORS = [
    "#7DFF8A",
    "#8175FF",
    "#0065BC",
    "#00EA98",
    "#00D2F2",
    "#007EEA",
    "#FF8664",
    "#FFE478",
    "#FF5BB2",
    "#C859FF",
  ];

  const isMobile = window.innerWidth < 600; // Detect mobile screen

  // <Pie
  //   label={!isMobile ? renderCustomizedLabel : null} // Hide labels on mobile
  // />
  const TopClientsChart = ({ data, total }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < 768); // mobile breakpoint
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const renderCustomizedLabel = ({
      cx,
      cy,
      midAngle,
      innerRadius,
      percent,
      outerRadius,
      index,
    }) => {
      if (isMobile) return null; // ✅ hide lines & text completely on mobile

      const RADIAN = Math.PI / 180;
      const radius = innerRadius + (outerRadius - innerRadius) * 1.23;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
      const isRight = Math.cos(-midAngle * RADIAN) > 0;
      const lineLength = isRight ? 80 : -80;
      const textOffset = isRight ? 20 : -20;
      const color = COLORS[index % COLORS.length];
      const squareSize = 12;

      return (
        <>
          <line
            x1={x}
            y1={y}
            x2={x + lineLength}
            y2={y}
            stroke="#BEBEBE"
            strokeWidth={1}
          />
          <rect
            x={x + lineLength + (isRight ? -squareSize : 0)}
            y={y - squareSize / 2}
            width={squareSize}
            height={squareSize}
            fill={color}
          />
          <text
            x={x + lineLength + textOffset}
            y={y}
            fill="#5F6D8C"
            textAnchor={isRight ? "start" : "end"}
            dominantBaseline="central"
            fontSize={14}
          >
            {`${clientsData[index].name} (${(percent * 100).toFixed(2)}%)`}
          </text>
        </>
      );
    };

    return (
      <Row>
        <Col xs={24} lg={2} xl={2}></Col>

        {/* Pie Chart */}
        <Col xs={24} lg={24} xl={24} style={{ order: 1, marginBottom: 16 }}>
          <Spin spinning={loading}>
            <ResponsiveContainer width="100%" height={500} id="Clients">
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius="40%"
                  outerRadius="76%"
                  fill="#8884d8"
                  cursor="pointer"
                  // ✅ Disable Recharts' built-in lines on mobile
                  labelLine={!isMobile}
                  // ✅ Disable labels on mobile (already handled above)
                  label={renderCustomizedLabel}
                  stroke={isMobile ? "none" : "#fff"}
                  dataKey="value"
                >
                  {clientsData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                      stroke={isMobile ? "none" : "#fff"}
                    />
                  ))}
                </Pie>

                {/* Center text */}
                <text
                  x="50%"
                  y="47%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={22}
                  fontWeight="bold"
                >
                  {total}
                </text>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={18}
                  fontWeight="bold"
                >
                  Trips
                </text>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </Spin>
        </Col>

        {/* ✅ Show data labels only on mobile */}
        {isMobile && (
          <Col xs={24} lg={24} xl={24} style={{ order: 2 }}>
            <div className="toptenclients" style={{ marginTop: "-160px" }}>
              {clientsData.map((client, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{
                      width: 12,
                      height: 12,
                      backgroundColor: COLORS[index % COLORS.length],
                      marginRight: 8,
                    }}
                  />
                  <span style={{ color: "#5F6D8C", fontSize: 14 }}>
                    {client.name}: {client.value}
                  </span>
                </div>
              ))}
            </div>
          </Col>
        )}

        <Col xs={24} lg={2} xl={2}></Col>
      </Row>
    );
  };

  const VehiclePerformanceChart = ({ data }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
      if (containerRef.current)
        setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        if (containerRef.current)
          setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Dynamic width for scrollable chart area
    const chartWidth = Math.max(data?.length * 80, containerWidth - 60); // 60 = Y-axis width

    // Compute min/max for Y-axis across selected widgets
    const allValues = data
      .flatMap((item) => [
        selectedWidgets?.includes(9) ? item.Fuel : null,
        selectedWidgets?.includes(10) ? item.Distance : null,
        selectedWidgets?.includes(11) ? item.Mileage : null,
      ])
      .filter((v) => v !== null);

    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <div
          ref={containerRef}
          style={{ display: "flex", width: "100%", background: "#fff" }}
        >
          {/* Fixed Y-axis */}
          <div
            style={{
              width: 60,
              height: 325,
              borderRight: "1px solid #eee",
              position: "sticky",
              left: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart data={data}>
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: "#666", textAnchor: "end" }}
                  width={60}
                  domain={[minValue, maxValue]} // Sync scale
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>

          {/* Scrollable chart area */}
          <div style={{ overflowX: "auto", flex: 1 }}>
            <div style={{ width: chartWidth, height: 325 }}>
              <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                  data={data}
                  margin={{ top: 40, right: 30, left: 0, bottom: 5 }}
                  barCategoryGap="25%"
                  barGap={0}
                  style={{ cursor: "pointer" }}
                >
                  <Legend
                    layout="horizontal"
                    align="center"
                    verticalAlign="top"
                    wrapperStyle={{
                      position: "absolute",
                      top: 0,
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRadius: "5px",
                    }}
                  />
                  <CartesianGrid vertical={false} horizontal={true} />
                  <XAxis
                    dataKey="Data"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 10, fill: "#666" }}
                  />
                  <Tooltip />
                  {selectedWidgets?.includes(9) && (
                    <Bar
                      dataKey="Fuel"
                      name="Fuel (L)"
                      fill="#68DCFF"
                      radius={[4, 4, 0, 0]}
                      barSize={16}
                    />
                  )}
                  {selectedWidgets?.includes(10) && (
                    <Bar
                      dataKey="Distance"
                      name="Distance (Km)"
                      fill="#FF73DB"
                      radius={[4, 4, 0, 0]}
                      barSize={16}
                    />
                  )}
                  {selectedWidgets?.includes(11) && (
                    <Line
                      type="basis"
                      dataKey="Mileage"
                      name="Mileage (Km/L)"
                      stroke="#E4A400"
                      dot={false}
                    />
                  )}
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <style>
          {`
            div::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
      </Spin>
    );
  };

  const [isSwitchChecked, setIsSwitchChecked] = useState(false);

  const [Mobile, setMobile] = useState(
    window.innerWidth >= 320 && window.innerWidth <= 426,
  );

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth >= 320 && window.innerWidth <= 426);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const onChange = (checked) => {
    setIsSwitchChecked(checked);
    getTrends();
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getUserWidget();
    getConsignmentAndDeliveryt();
    getTripPerVehicle();
    getClients();
    getCardData();
    getVehiclePerformance();
  }, [formValues]);

  return (
    <>
      {/* <Row className="Button-Wrap">
      <div style={{ display: "flex", gap: "8px" }}>
            <DashboardButton style={{ minWidth: 160,minHeight:50 }} onClick={()=> navigate("/Dashboard")}>TrackRightAI</DashboardButton>
            <DashboardButton style={{ minWidth: 160,minHeight:50  }} onClick={()=> navigate("/container-dashboard")}>Container Tracking</DashboardButton>
            <DashboardButton style={{ minWidth: 160,minHeight:50 }} >Trackright AI+</DashboardButton>
      </div> AI+ Overview
      </Row> */}

      <div>
        <DashboardNav></DashboardNav>
      </div>
      <div className="dashboard-content">
        <Styledashboard>
          <div className="overview-body">
            <div bordered={false} className="overview-body ai-overview">
              {/* --- First row: Title --- */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                  }}
                  title="AI+ Overview"
                >
                  {/* AI+ Overview */}
                </span>
              </div>

              {/* --- Second row: Controls (Trends + Switch, Add Widget + Filter) --- */}
              <Card
                style={{
                  marginBottom: 16,
                  borderRadius: "8px",
                  border: "none",
                  borderTopLeftRadius: isMobile ? "0px" : "8px",
                  borderTopRightRadius: isMobile ? "0px" : "8px",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                  overflowX: "auto", // ✅ prevents overflow by allowing scroll
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "nowrap",
                    gap: "12px",
                    overflowX: "scroll",
                  }}
                >
                  {/* Left side: Trends + Switch */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flexShrink: 0,
                    }}
                  >
                    <span
                      className="trends-value"
                      style={{
                        color: "#5F6D8C",
                        fontSize: "18px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Trends
                    </span>
                    <Switch onChange={onChange} color="#31AB46" />
                  </div>

                  {/* Right side: Add Widget + Filter */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flexShrink: 0,
                    }}
                  >
                    <div className="dropstyle">
                      <Select
                        placeholder="Custom Range"
                        value={formValues?.Duration}
                        onChange={(value) =>
                          setFormValues((prev) => ({
                            ...prev,
                            Duration: value,
                          }))
                        }
                      >
                        {Duration.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    <div className="dropstyle1">
                      <Space direction="vertical" size={12}>
                        <RangePicker
                          value={formValues?.Daterange}
                          onChange={(value) =>
                            setFormValues((prev) => ({
                              ...prev,
                              Daterange: value,
                            }))
                          }
                        />
                      </Space>
                    </div>
                    <ButtonFilled
                      className="addwidget-btn"
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                    >
                      + Add Widget
                    </ButtonFilled>

                    <div
                      className="Iconbg"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#F5F6FA",
                        borderRadius: "8px",
                        padding: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={FilterIcon}
                        alt="Filter Icon"
                        width={20}
                        height={20}
                        style={{ display: "block" }}
                        onClick={() => setIsFilterModalOpen(true)}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "16px" }}>
                  <Spin spinning={loading}>
                    <Row gutter={[16, 16]}>
                      {cardOrder
                        .filter((num) => selectedWidgets.includes(num)) // Only show selected widgets
                        .map((num) =>
                          cardDatas.find((card) => card.number === num),
                        )
                        .map((item, index) => {
                          return (
                            <Col
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              key={item.number}
                              draggable
                              onDragStart={() => handleDragStart(index)}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={() => handleDrop(index)}
                              style={{ cursor: "grab" }}
                            >
                              <Card
                                title={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "8px",
                                      width: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <span
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              fontSize: "13px",
                                              padding: "4px",
                                              textWrap: "wrap",
                                            }
                                          : {
                                              fontSize: "15px",
                                              fontWeight: 500,
                                              lineHeight: 1.3,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              flex: 1,
                                              minWidth: 0,
                                              whiteSpace: "normal",
                                              overflowWrap: "break-word",
                                            }
                                      }
                                      className="card-title-text"
                                      title={item.title}
                                    >
                                      {item.title}
                                      {item.leafimg && (
                                        <span style={{ marginLeft: "5px" }}>
                                          {item.leafimg}
                                        </span>
                                      )}
                                    </span>

                                    <div style={{ flexShrink: 0 }}>
                                      <CloseOutlined
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          AddRemoveWidgets(`${item.number}`, 0)
                                        }
                                      />
                                    </div>
                                  </div>
                                }
                                bordered={false}
                                style={{
                                  backgroundColor: item.background,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  wordBreak: "break-word",
                                  height: "100%", // ✅ Full block height (matches siblings)
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                                bodyStyle={{
                                  paddingTop: 0,
                                  flexGrow: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                    overflow: "hidden",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="stats-card"
                                    style={{
                                      textAlign: "left",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <h4
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              fontSize: "17px",
                                              padding: "4px",
                                              textWrap: "wrap",
                                            }
                                          : {
                                              margin: 0,
                                              textAlign: "left",
                                            }
                                      }
                                      title={item.value}
                                    >
                                      {item.value}
                                    </h4>
                                    <p
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              fontSize: "14px",
                                              padding: "4px",
                                              textWrap: "wrap",
                                            }
                                          : {
                                              margin: "4px 0",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }
                                      }
                                      title={item.subtitle}
                                    >
                                      {item.subtitle}
                                    </p>
                                  </div>

                                  {isSwitchChecked && (
                                    <div
                                      className="status_card1"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        gap: "6px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {item.color && (
                                        <p
                                          className={
                                            item.color === "G"
                                              ? "text-success"
                                              : item.color === "R"
                                                ? "text-danger"
                                                : ""
                                          }
                                          style={{
                                            margin: 0,
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          ({item.percent}%)
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </Card>
                            </Col>
                          );
                        })}
                    </Row>
                  </Spin>
                </div>
              </Card>
            </div>
          </div>
          {/* <Card>
              <div style={{ marginTop: "16px" }}>
                  <Spin spinning={loading}>
                    <Row gutter={[16, 16]}>
                      {cardOrder
                        .filter((num) => selectedWidgets.includes(num)) // Only show selected widgets
                        .map((num) =>
                          cardDatas.find((card) => card.number === num)
                        )
                        .map((item, index) => {
                          return (
                            <Col
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              key={item.number}
                              draggable
                              onDragStart={() => handleDragStart(index)}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={() => handleDrop(index)}
                              style={{ cursor: "grab" }}
                            >
                              <Card
                                title={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "8px",
                                      width: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <span
                                      style={
                                         window.innerWidth >= 320 && window.innerWidth <= 425 ? {
                                         fontSize: "10px",
                                         padding:"4px",
                                         textWrap:"wrap"
                                      } : {
                                        fontSize: "15px",
                                        fontWeight: 500,
                                        lineHeight: 1.3,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        minWidth: 0,
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                      }}
                                      className="card-title-text"
                                      title={item.title}
                                    >
                                      {item.title}
                                      {item.leafimg && (
                                      <span style={{marginLeft:"5px"}}>
                                        {item.leafimg}
                                      </span>
                                    )}
                                    </span>

                                    <div style={{ flexShrink: 0 }}>
                                      <CloseOutlined
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          AddRemoveWidgets(`${item.number}`, 0)
                                        }
                                      />
                                    </div>
                                  </div>
                                }
                                bordered={false}
                                style={{
                                  backgroundColor: item.background,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  wordBreak: "break-word",
                                  height: "100%", // ✅ Full block height (matches siblings)
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                                bodyStyle={{
                                  paddingTop: 0,
                                  flexGrow: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                    overflow: "hidden",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="stats-card"
                                    style={{
                                      textAlign: "left",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <h4
                                      style={window.innerWidth >= 320 && window.innerWidth <= 425 ? {
                                         fontSize: "10px",
                                         padding:"4px",
                                       textWrap:"wrap"
                                      } :  {
                                        margin: 0,
                                        textAlign: "left",
                                      }}
                                      title={item.value}
                                    >
                                      {item.value}
                                    </h4>
                                    <p
                                      style={ window.innerWidth >= 320 && window.innerWidth <= 425 ? {
                                         fontSize: "10px",
                                         padding:"4px",
                                       textWrap:"wrap"
                                      } :  
                                        {
                                        margin: "4px 0",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                      title={item.subtitle}
                                    >
                                      {item.subtitle}
                                    </p>
                                  </div>

                                  {isSwitchChecked && (
                                    <div
                                      className="status_card1"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        gap: "6px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {item.color && (
                                        <p
                                          className={
                                            item.color === "G"
                                              ? "text-success"
                                              : item.color === "R"
                                              ? "text-danger"
                                              : ""
                                          }
                                          style={{
                                            margin: 0,
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          ({item.percent}%)
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </Card>
                            </Col>
                          );
                        })}
                    </Row>
                  </Spin>
                </div>
            </Card> */}
          <div
            className="all-charts-scroll-container"
            style={{ marginTop: "16px" }}
          >
            {/* {[1].some((id) => selectedWidgets?.includes(id)) && ( */}
            <Card
              className="chart-card"
              bordered={false}
              id="Consignment Vs Delivered"
              style={{ overflowX: "auto" }}
            >
              {/* Custom Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "nowrap",
                  gap: "8px",
                  padding: "0 8px 8px 8px",
                }}
              >
                {/* Title with ellipsis */}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    color: "#000",
                    // whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1, // title takes remaining space
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                  }}
                  title="Total Consignment & Delivered"
                >
                  Total Consignment & Delivered
                </span>

                {/* Right-aligned Icons */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "10px",
                    flexShrink: 0,
                  }}
                >
                  <LeftOutlined
                    onClick={handlePrev}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                  <RightOutlined
                    onClick={handleNext}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                  <div className="Iconbg">
                    <img
                      title="Export Icon"
                      src={ExportIcon}
                      alt="Export Icon"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Consignment Vs Delivered",
                          "Consignment Vs Delivered",
                        );
                      }}
                    />
                  </div>
                  <CloseOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => AddRemoveWidgets("1", 0)}
                  />
                </div>
              </div>

              {/* Chart Content */}
              <ConsigndeliveryChart data={paginatedData} />
            </Card>

            {/* // )} */}
          </div>

          <div className="all-charts-scroll-container">
            {[8].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Trip Per Vehicle"
                style={{ overflowX: "auto" }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title with ellipsis */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // title takes remaining space
                    }}
                    title="Trips Per Vehicle"
                  >
                    Trips Per Vehicle
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "10px",
                      flexShrink: 0,
                    }}
                  >
                    <LeftOutlined
                      onClick={tripHandlePrev}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <RightOutlined
                      onClick={tripHandleNext}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Trip Per Vehicle",
                            "Trip Per Vehicle",
                          );
                        }}
                      />
                    </div>
                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("8", 0)}
                    />
                  </div>
                </div>

                <div className="tripPaginatedData">
                  {/* Chart Content */}
                  <TripPerVehicleChart
                    className="trippervehicle_chart"
                    data={tripPaginatedData}
                  />
                </div>
              </Card>
            )}
          </div>

          <div className="all-charts-scroll-container">
            {[3].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Clients"
                style={{ overflowX: "auto" }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title with ellipsis */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // title takes remaining space
                    }}
                    title="Top 10 Clients"
                  >
                    Top 10 Clients
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "10px",
                      flexShrink: 0,
                    }}
                  >
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart("Clients", "Clients");
                        }}
                      />
                    </div>
                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("3", 0)}
                    />
                  </div>
                </div>

                {/* Chart Content */}
                <TopClientsChart
                  className="donut-chart"
                  totel={total}
                  data={paginatedClients}
                />
              </Card>
            )}
          </div>

          <div
            style={{
              overflowX: "scroll",
            }}
            className="all-charts-scroll-container"
          >
            {[9, 10, 11].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                className="chart-card"
                bordered={false}
                id="Vehicle Performance"
                style={{ overflowX: "auto" }}
              >
                {/* Custom Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    gap: "8px",
                    padding: "0 8px 8px 8px",
                  }}
                >
                  {/* Title with ellipsis */}
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1, // title takes remaining space
                    }}
                    title="Vehicle Performance"
                  >
                    Vehicle Performance
                  </span>

                  {/* Right-aligned Icons */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "10px",
                      flexShrink: 0,
                    }}
                  >
                    <LeftOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehiclePrev}
                    />
                    <RightOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehicleNext}
                    />
                    <div className="Iconbg">
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Vehicle Performance",
                            "Vehicle Performance",
                          );
                        }}
                      />
                    </div>
                    <CloseOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => AddRemoveWidgets("9,10,11", 0)}
                    />
                  </div>
                </div>

                {/* Chart Content */}
                <VehiclePerformanceChart data={paginatedVehicleData} />
              </Card>
            )}
          </div>
        </Styledashboard>
      </div>

      <UIModal
        header="Add Widgets"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        footer={[
          <div
            key="footer"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              onClick={() => {
                setIsModalOpen(false);
                getUserWidget();
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              className="w-50 px-3"
              loading={loading}
              onClick={() =>
                AddRemoveWidgets(
                  selectedWidgets?.map((item) => item).join(","),
                  1,
                )
              }
            >
              Add Widgets
            </ButtonFilled>
          </div>,
        ]}
        size="550px"
        closeButton={false}
      >
        <div className="">
          <Select
            mode="multiple"
            value={selectedWidgets}
            onChange={handleChange}
            placeholder="Select"
            style={{ width: "100%" }}
            maxTagCount="responsive"
            dropdownRender={(menu) => (
              <>
                <div style={{ padding: "5px" }}>
                  <Checkbox
                    checked={selectedWidgets?.length === widgets.length}
                    onChange={(e) =>
                      handleChange(e.target.checked ? ["all"] : [])
                    }
                  >
                    Select All
                  </Checkbox>
                </div>
                <div style={{ padding: "5px" }}>
                  <Input
                    placeholder="Search"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                {menu}
              </>
            )}
          >
            {filteredWidgets.map((role) => (
              <Option key={role?.value} value={role?.value}>
                <Checkbox checked={selectedWidgets?.includes(role?.value)}>
                  {role?.name}
                </Checkbox>
              </Option>
            ))}
          </Select>
        </div>
      </UIModal>
      <Modal
        open={isfilterModalOpen}
        onCancel={handleCancel}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              const resetValues = {
                Duration: "CurrentMonth",
                vehicle: undefined,
                consignor: undefined,
                transporter: undefined,
                consignee: undefined,
                tripType: undefined,
                driver: undefined,
              };

              form.resetFields();
              form.setFieldsValue(resetValues);
              setFormValues(resetValues);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Styledashboard>
          {" "}
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(changed, allvalues) => {
              setFormValues({...formValues,...allvalues});
              getFilterCount();
            }}
            initialValues={formValues}
          >
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Vehicle" name="vehicle">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={vehicleList?.map((item) => ({
                      label: item.REGNO,
                      value: item.VEHID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignee" name="consignee">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consigneeList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={12} sm={12} md={6}>
                <Form.Item label="Duration" name="Duration">
                  <Select>
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Date Range" name="Daterange">
                  <RangePicker
                    className="range_picker"
                    defaultPickerValue={[dayjs(), dayjs()]}
                    value={null}
                    allowClear
                  />
                </Form.Item>
              </Col> */}

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Trip Type" name="tripType">
                  <Select className="w-100" showSearch allowClear>
                    <Option value={2}>Safari</Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Driver" name="driver">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={driverList?.map((item) => ({
                      label: item.FULLNM,
                      value: item.UID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Styledashboard>
      </Modal>
    </>
  );
};

export default AIDashboard;
